import { FieldArray } from 'react-final-form-arrays';

import { useClientRequiredFieldsAndPod } from '../hooks/useClientRequiredFieldsAndPod';

import Card from './Card';
import RequiredFieldItem from './RequiredFieldItem';

interface OrderRequiredFieldsProps {
  className?: string;
  hideHeader?: boolean;
  removeContainer?: boolean;
}

export default function OrderRequiredFields({
  className = '',
  hideHeader = false,
  removeContainer: noCard = false,
}: OrderRequiredFieldsProps) {
  const { clientRequiredFields } = useClientRequiredFieldsAndPod();

  const content = (
    <>
      {!hideHeader && (
        <h2 className="mb-4 text-base font-bold">Reservation Details</h2>
      )}
      <FieldArray name="requiredFields">
        {({ fields }) => (
          <>
            {fields.map((name, index) => {
              const fieldItem = fields.value[index];
              const fieldType = fieldItem?.name;

              if (!fieldType) return null;

              const fieldConfig = clientRequiredFields.find(
                ({ value }) => value === fieldType,
              );
              if (!fieldConfig) return null;

              return (
                <RequiredFieldItem
                  key={index}
                  name={`${name}.value`}
                  label={fieldConfig.label}
                  fieldType={fieldType}
                />
              );
            })}
          </>
        )}
      </FieldArray>
    </>
  );

  if (noCard) {
    return <div className={className}>{content}</div>;
  }

  return <Card className={`col-span-2 ${className}`}>{content}</Card>;
}
